module.exports = __webpack_public_path__ + "img/pad-lock.4bcdd359.svg";